// extracted by mini-css-extract-plugin
module.exports = {"appError":"AppError_app-error__3rB0t"};